import { render } from "./match-details-table-row.vue?vue&type=template&id=476dc981&scoped=true&ts=true"
import script from "./match-details-table-row.vue?vue&type=script&lang=ts"
export * from "./match-details-table-row.vue?vue&type=script&lang=ts"

import "./match-details-table-row.vue?vue&type=style&index=0&id=476dc981&lang=scss&scoped=true"
import "./match-details-table-row.vue?vue&type=style&index=1&id=476dc981&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476dc981"]])

export default __exports__